import { capitalize, splitByUppercase } from '../../../utils/text.js'
import { TextInput } from '../../TextInput/index.js'

// export type SchemaBinary = Prop<{
//     type: 'binary';
//     default?: Uint8Array;
//     maxBytes?: number;
//     mime?: Mime;
//     format?: StringFormat;
// }>;

export const BinaryType = ({ value, onChange, schemaProp, name, disabled }) => {
  const { title, description, readOnly, max, format } = schemaProp

  return (
    <TextInput
      value={value}
      onChange={(v) => {
        if (onChange) {
          onChange(v, name)
        }
      }}
      label={capitalize(splitByUppercase(title ?? name))}
      description={description}
      disabled={readOnly || disabled}
      maxLength={max}
      // error={errored}
      // placeholder={field.placeholder}
    />
  )
}
